import styled from 'styled-components'

export const TimelineTab = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr 1fr;
`

